__turbopack_context__.v({
  "buttons-container": "search-bar-module-scss-module__sz_aFW__buttons-container",
  "clear-button": "search-bar-module-scss-module__sz_aFW__clear-button",
  "input": "search-bar-module-scss-module__sz_aFW__input",
  "input-icon": "search-bar-module-scss-module__sz_aFW__input-icon",
  "search-bar": "search-bar-module-scss-module__sz_aFW__search-bar",
  "wrapper": "search-bar-module-scss-module__sz_aFW__wrapper",
});
